import React from 'react';
import { useParams } from 'react-router-dom';
import InventoryCountPanel from '../../components/Audit/InventoryCountPanel';

export default function WarehouseInventoryCountPage() {
  const { warehouseId } = useParams();
  return <InventoryCountPanel warehouseId={warehouseId} mode="warehouse" />;
}
